import { FormControl, InputLabel, MenuItem, Select, SelectProps } from "@mui/material"
import { styled } from "@mui/styles"

export const StyledFormControl = styled(FormControl)({
  "&.MuiFormControl-root": {
    "& .MuiFormHelperText-root": {
      marginLeft: 0
    },
    margin: 0
  }
})

export const StyledInputLabel = styled(InputLabel)({
  "&.MuiInputLabel-root": {
    "&[data-shrink='true']": {
      fontSize: "1.6rem"
    },
    color: "#0000008a",
    fontSize: "1.4rem"
  },
  marginTop: -4
})

export type StyledSelectProps = SelectProps & {
  background?: string,
  backgroundOnHover?: string,
  fontColor?: string,
  theme?: any,
  noBorders?: boolean,
}

export const StyledSelect = styled(Select)(
  ({
     label,
     color,
     fontColor = "#333333",
     background = "#F1F3F4",
     backgroundOnHover = "#F1F3F4",
     theme: { withPalette, typography },
     noBorders
   }: StyledSelectProps) => ({
    "&:before, &:after": {
      display: noBorders ? "none" : "inherit",
    },
    "& .selector-placeholder": {
      color: "#00000099"
    },
    "& .MuiSelect-outlined": {
      "&.MuiInputBase-input": {
        padding: "0 16px",
        height: "44px",
        display: "flex",
        alignItems: "center",
      }
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none"
    },
    "& .MuiInputBase-input": {
      "&:focus": {
        background,
        borderRadius: 4
      },
      "&:hover": {
        background: backgroundOnHover
      },
      background,
      borderRadius: 4,
      color: withPalette(color, fontColor, "contrastText"),
      fontSize: typography.pxToRem(14),
      lineHeight: typography.pxToRem(28),
      fontWeight: 400,
      paddingBottom: label ? 0 : 8,
      paddingLeft: 12,
      paddingRight: 45,
      paddingTop: label ? 16 : 8
    },
    borderRadius: 4
  })
)

export const StyledMenuItem = styled(MenuItem)(({ theme: { typography } }: any) => ({
  "&.MuiMenuItem-root": {
    "&[aria-selected='true']": {
      "&.Mui-selected": {
        backgroundColor: "#efefef"
      }
    },
    color: "#333333",
    fontSize: typography.pxToRem(14),
    fontWeight: 400,
    padding: `${typography.pxToRem(6)} ${typography.pxToRem(16)}`,
    height: "32px"
  }
}))
